export const paidPlansEnabled = (state = false): boolean => state
